<template>
  <transition name="fade" mode="out-in">
    <keep-alive include="applicants-history">
      <router-view></router-view>
    </keep-alive>
  </transition>
</template>
<script>
  export default {}
</script>